import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import { connect } from "react-redux";
import {
  Grid,
  Button,
  Select,
  Divider,
  TextField,
  InputLabel,
  Typography,
  FormControl,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Tooltip,
} from "@material-ui/core";
import dayjs from "dayjs";
import { Autocomplete } from "@material-ui/lab";
import { CheckBox, Visibility, CheckBoxOutlineBlank } from "@material-ui/icons";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import MultiFileManager from "../../File/MultiFileManager/MultiFileManager";
import RewardBonusCheckboxGroup from "../RewardBonusCheckboxGroup";
import Other from "../ScientificResearchInsertForm/Other";
import Chapter from "../ScientificResearchInsertForm/Chapter";
import Conference from "../ScientificResearchInsertForm/Conference";
import WorkingPaper from "../ScientificResearchInsertForm/WorkingPaper";
import JournalDomestic from "../ScientificResearchInsertForm/JournalDomestic";
import ConferenceDomestic from "../ScientificResearchInsertForm/ConferenceDomestic";
import JournalInternational from "../ScientificResearchInsertForm/JournalInternational";
import EmploymentContractTable from "../../../components/EmployContractModal/EmploymentContractTable";
import EmploymentContractDetailTable from "../../../components/EmployContractModal/EmploymentContractDetailTable";

import { uploadMultiFile } from "../../../reducer/file/action";
import { statisticUnaccepted } from "../../../reducer/profile/action";
import { updateScientificResearch, acceptScientificResearch, requestRevisionScientificResearch } from "../../../reducer/scientificResearch/action";
import { ModalWorkflowActions } from "../../../components/WorkflowStatus";
import { updateScientificResearchOther } from "../../../reducer/scientificResearchOther/action";
import {
  getEmploymentContractById,
  getAllEmploymentContractByProfileId,
} from "../../../reducer/employmentContract/action";
import { getJournalByIdOnScientificResearch } from "../../../reducer/journal/action";
import { getAllJournalDomestic } from "../../../reducer/journalDomestic/action";
import { getAllConference } from "../../../reducer/conference/action";
import ROUTER from "../../../constants/router";
import { notification } from "reducer/home/action";

function ScientificResearchUpdateModal(props) {
  const { employmentContractDetail, updating, setUpdating, readOnly } = props;
  // When opened in readOnly mode (e.g. from ProjectUpdateModal → "Chi tiết" on
  // a linked paper), force the form into disabled state and hide all mutating
  // controls so the dialog renders as a pure paper viewer.
  const [disabled, setDisabled] = useState(!!readOnly);
  useEffect(() => {
    if (readOnly) setDisabled(true);
  }, [readOnly, updating]);

  const [focusProfile, setFocusProfile] = useState(null);

  const [detail, setDetail] = useState(null);
  const [values, setValues] = useState(null);
  const [divideKPI, setDivideKPI] = useState(false);
  const [KPIList, setKPIList] = useState([]);
  // profileList holds non-student members; studentList is split out per UX request so
  // each kind of contributor has its own box. Merged on submit so the BE shape is unchanged.
  const [profileList, setProfileList] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [helperText, setHelperText] = useState(false);
  const [timeResearchYear, setTimeResearchYear] = useState(0);
  // Two parallel lists: legacy "Loại công trình" (bonus_code empty) drives hours/points;
  // "Loại công trình tính thưởng" (bonus_code != '') drives reward value lookup.
  const [timeResearchDetailList, setTimeResearchDetailList] = useState([]);
  const [timeResearchDetailListForBonus, setTimeResearchDetailListForBonus] = useState([]);
  const [fileUrls, setFileUrls] = useState([]);
  const [newFiles, setNewFiles] = useState([]);

  // console.log("updating", updating);

  const isCheckedForKPI = (profile) => {
    if (divideKPI) return KPIList.find((e) => e?.profileId === profile.profileId);

    return typeof values?.profileIdForKpi === "number" && values?.profileIdForKpi === profile.profileId;
  };

  const dateFormat = (value) => (value ? dayjs(value).format("YYYY-MM-DDTHH:mm:ssZ") : null);

  useEffect(() => {
    if (updating !== null) {
      resetValues();
      const urls = updating?.fileUrl ? updating.fileUrl.split("||").filter(Boolean) : [];
      setFileUrls(urls);
      setNewFiles([]);
    }
    if (props.listJournalDomestic?.length === 0) props.getAllJournalDomestic();
    if (props.listConference?.length === 0) props.getAllConference();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updating]);

  // Auto-ranking effect riêng để tránh conflict với resetValues
  useEffect(() => {
    if (updating !== null && updating?.journalId && updating?.journalId > 0) {
      props.getJournalByIdOnScientificResearch(updating?.journalId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updating?.journalId]);

  useEffect(() => {
    if (values?.profileIdForKpi) props.getAllEmploymentContractByProfileId(values?.profileIdForKpi);
  }, [values?.profileIdForKpi]);

  useEffect(() => {
    if (employmentContractDetail)
      setValues({
        ...values,
        profileIdForKpi: employmentContractDetail?.profile?.id,
      });
  }, [employmentContractDetail]);

  useEffect(() => {
    const contract = props?.employmentContractListById?.find(
      (e) => e?.contract?.id === updating?.contractIdForKpi,
    )?.contract;
    if (contract?.duration !== 1000) {
      if (contract?.kpi?.id === updating?.kpiIdForKpi) setDetail(contract?.kpi);
    } else {
      setDetail(contract?.listKpi?.find((e) => e.id === updating?.kpiIdForKpi));
    }
  }, [props?.employmentContractListById, updating?.contractIdForKpi]);

  useEffect(() => {
    setDetail(null);
    setValues(null);
    setProfileList([]);
    setStudentList([]);
  }, [props.filter]);

  useEffect(() => {
    if (values?.timeResearchDetailCode) {
      const selectedYear = props.timeResearchInformationList?.find(
        (info) => !!info.timeResearchDetail.find((detail) => detail.code === values?.timeResearchDetailCode),
      )?.year;

      setTimeResearchYear(selectedYear);
    }
  }, [values?.timeResearchDetailCode]);

  useEffect(() => {
    if (values && props.isUploading === false && props.fileUrl !== "") {
      const listKpiIdForKpi = JSON.stringify(
        KPIList.map((e) => ({
          ...e,
          coef: parseFloat(e?.coef),
        })),
      );

      const tempListAuthor = values?.listAuthor?.split(",").map((author) => author.trimStart());
      setValues({
        ...values,
        fileUrl: props.fileUrl,
      });
      if (values.id) {
        // Re-merge here so post-upload save also keeps students intact.
        const mergedListEffect = [
          ...profileList,
          ...studentList.map((s) => ({ ...s, isInternal: false, isStudent: true, profileId: null })),
        ];
        props.updateScientificResearch(values.id, {
          ...values,
          purpose: undefined,
          roleInPaper: undefined,
          listAuthor: tempListAuthor,
          researchProjectProfile: mergedListEffect,
          journalId: values?.journalId,
          journalDomesticId: values?.journalDomesticId,
          conferenceId:
            props.filter === "conference"
              ? values.conferenceId
              : props.filter === "conferenceDomestic"
                ? values.conferenceDomesticId
                : null,
          conferenceDomesticId: null,
          profileId: props.profile?.id,
          scientificResearchProfile: mergedListEffect,
          type: props.type,
          fileUrl: props.fileUrl,
          listKpiIdForKpi: divideKPI ? listKpiIdForKpi : null,
          acceptedDay: dateFormat(values?.acceptedDay),
          submissionDay: dateFormat(values?.submissionDay),
          dashboardYear: new Date(dateFormat(values?.acceptedDay)).getFullYear(),
        });
      }
    }
  }, [props.isUploading]);

  const resetValues = () => {
    let tempListAuthor = "";
    updating.listAuthor?.forEach((author) => {
      if (tempListAuthor === "") tempListAuthor += author;
      else tempListAuthor += `, ${author}`;
    });

    if (updating?.listKpiIdForKpi) {
      const listKpiIdForKpi = JSON.parse(updating?.listKpiIdForKpi);
      setKPIList(listKpiIdForKpi);
      if (listKpiIdForKpi) setDivideKPI(true);
    }

    const newValues = {
      ...updating,
      listAuthor: tempListAuthor,
      journalId: updating?.journalId,
      journalDomesticId: updating?.journalDomesticId,
      conferenceId:
        props.filter === "conference"
          ? updating.conferenceId
          : props.filter === "conferenceDomestic"
            ? updating.conferenceDomesticId
            : null,
      conferenceDomesticId: null,
      profileId: props.profile?.id,
      // resetValues is initialization only; use the BE shape verbatim.
      scientificResearchProfile: updating.scientificResearchProfile || [],
      type: props.type,
      acceptedDay: new Date(updating.acceptedDay),
      submissionDay: new Date(updating.submissionDay),
      dashboardYear: new Date(dateFormat(new Date(updating.acceptedDay))).getFullYear(),
    };
    setValues(newValues);
    // Split incoming members into the two boxes: students vs everyone else.
    const incomingMembers = updating.scientificResearchProfile || [];
    setProfileList(incomingMembers.filter((m) => !m.isStudent));
    setStudentList(incomingMembers.filter((m) => !!m.isStudent));

    // props.getEmploymentContractById(updating.contractIdForKpi);

    // const contract = props.employmentContractListById?.find(
    //   (e) => e.contract.id === updating.contractIdForKpi
    // )?.contract;
    // setDetail(contract?.listKpi?.find((e) => e.id === updating.kpiIdForKpi));

    const timeResearchYearId = parseInt(updating.timeResearchDetailCode?.split("-")[0]);
    const year = props.timeResearchInformationList?.find((e) => e.id === timeResearchYearId)?.year || 2022;
    setTimeResearchYear(year);
  };

  // Tự động lấy thông tin xếp hạng khi mở modal update và có journalId
  useEffect(() => {
    if (values?.journalId && values?.journalId > 0) {
      props.getJournalByIdOnScientificResearch(values?.journalId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.journalId]);

  // Hiển thị thông báo khi load xong thông tin xếp hạng
  useEffect(() => {
    if (props.journalDetail && !props.isFetchingJournalDetail && values?.journalId > 0) {
      if (props.journalDetail.sjrBestQuartile || props.journalDetail.abdcRanking || props.journalDetail.impactFactor) {
        props.notification({
          type: "success",
          message: "✅ Đã tự động tải thông tin xếp hạng của tạp chí!",
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isFetchingJournalDetail, props.journalDetail]);

  const handleChangeForm = (name, value) => {
    if (name === "timeResearchDetailCode") {
      const normalized = value === "null" ? null : value;
      setValues({ ...values, [name]: normalized });
      // Auto-fill bonus picker when same code exists in the bonus list and user hasn't
      // set a bonus code yet (or is fine with override). See InsertModal for rationale.
      if (
        normalized &&
        (values?.purposeId === 2 || values?.purposeId === 99999999)
      ) {
        const match = timeResearchDetailListForBonus?.find((d) => d.code === normalized);
        if (match) {
          setValues((prev) => ({
            ...prev,
            timeResearchDetailCode: normalized,
            timeResearchDetailCodeForBonus: match.code,
          }));
        }
      }
    } else if (name === "timeResearchDetailCodeForBonus") {
      setValues({ ...values, [name]: value === "null" ? null : value });
    } else if (name === "purposeId") {
      setValues({
        ...values,
        [name]: value,
        profileIdForKpi: null,
        kpiIdForKpi: null,
        contractIdForKpi: null,
        profileIdForReward: null,
      });
    } else {
      setValues({ ...values, [name]: value });
    }
  };

  // Auto-fill bonus picker when purpose flips to "Tính thưởng" with code already set,
  // or when the bonus list arrives later. Never overrides an existing user choice.
  useEffect(() => {
    const isReward = values?.purposeId === 2 || values?.purposeId === 99999999;
    if (!isReward) return;
    if (!values?.timeResearchDetailCode) return;
    if (values?.timeResearchDetailCodeForBonus) return;
    const match = timeResearchDetailListForBonus?.find((d) => d.code === values.timeResearchDetailCode);
    if (match) setValues((prev) => ({ ...prev, timeResearchDetailCodeForBonus: match.code }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.purposeId, values?.timeResearchDetailCode, timeResearchDetailListForBonus]);

  const handleChangeProfileList = (index, name, value) => {
    const temp = profileList;
    const tempElm = profileList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setProfileList([...temp]);
  };

  const handleInsert = () => {
    const temp = profileList;
    temp.push({
      profileId: null,
      roleInPaper: "main",
      isInternal: true,
      isStudent: false,
      externalName: "",
      orgCount: 1,
      orgRatio: 1,
    });
    setProfileList([...temp]);
  };

  const handleRemove = (index) => {
    if (profileList[index].profileId === values?.profileIdForKpi) handleChangeForm("profileIdForKpi", null);

    const temp = profileList.filter((e, id) => id !== index);
    setProfileList([...temp]);
  };

  // ---- Student list handlers (separate box) ----
  const handleChangeStudentList = (index, name, value) => {
    const temp = [...studentList];
    temp.splice(index, 1, { ...temp[index], [name]: value });
    setStudentList(temp);
  };
  const handleInsertStudent = () => {
    setStudentList([
      ...studentList,
      {
        profileId: null,
        isInternal: false,
        isStudent: true,
        roleInPaper: "member",
        statusInProject: "K",
        externalName: "",
        studentName: "",
        studentCode: "",
        studentClass: "",
        orgCount: 1,
        orgRatio: 1,
      },
    ]);
  };
  const handleRemoveStudent = (index) => {
    setStudentList(studentList.filter((_, id) => id !== index));
  };

  const handleSendFeedback = () => {
    props.history.push({
      pathname: ROUTER.NOTIFICATION,
      state: {
        sendTo: "personal",
        title: "Thông báo về sai sót thông tin trong CTKH",
        chosenProfiles: profileList.reduce((accumulator, currentValue) => {
          accumulator.push(currentValue.profileId);
          return accumulator;
        }, []),
        data: updating,
        dataType: "scientificResearch",
      },
    });
  };

  const handleSubmit = async (e) => {
    const listKpiIdForKpi = JSON.stringify(
      KPIList.map((e) => ({
        ...e,
        coef: parseFloat(e?.coef),
      })),
    );

    const hasInvalidProfile = profileList.some((m) => {
      if (m.isInternal === false) return !m.externalName;
      return m.profileId === null || m.profileId === undefined;
    });
    const hasInvalidStudent = studentList.some((s) => !s.studentName);
    const hasInvalid = hasInvalidProfile || hasInvalidStudent;

    // Merge profileList + studentList for the BE shape (single ScientificResearchProfile[]).
    const mergedList = [
      ...profileList,
      ...studentList.map((s) => ({ ...s, isInternal: false, isStudent: true, profileId: null })),
    ];

    if (!hasInvalid) {
      // Upload new files if any
      let updatedFileUrl = fileUrls.join("||");
      if (newFiles.length > 0) {
        const uploadType = props.filter !== "other" ? "scientificResearch" : "scientificResearchOther";
        const uploadResult = await props.uploadMultiFile(values.id, newFiles, uploadType);
        if (uploadResult.success) {
          const allUrls = [...fileUrls, ...uploadResult.data];
          updatedFileUrl = allUrls.join("||");
        }
      }

      const tempListAuthor = values?.listAuthor?.split(",").map((author) => author.trimStart());
      props
        .updateScientificResearch(values.id, {
          ...values,
          purpose: undefined,
          roleInPaper: undefined,
          listAuthor: tempListAuthor,
          researchProjectProfile: mergedList,
          journalId: values?.journalId,
          journalDomesticId: values?.journalDomesticId,
          conferenceId:
            props.filter === "conference"
              ? values.conferenceId
              : props.filter === "conferenceDomestic"
                ? values.conferenceDomesticId
                : null,
          conferenceDomesticId: null,
          profileId: props.profile?.id,
          scientificResearchProfile: mergedList,
          type: props.type,
          listKpiIdForKpi: divideKPI ? listKpiIdForKpi : null,
          acceptedDay: dateFormat(values?.acceptedDay),
          submissionDay: dateFormat(values?.submissionDay),
          dashboardYear: new Date(dateFormat(values?.acceptedDay)).getFullYear(),
          fileUrl: updatedFileUrl,
        })
        .then((success) => {
          if (success) {
            props.statisticUnaccepted({
              departmentId: 0,
              profileId: props.profile?.id,
            });
            if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
          }
        });

      setValues(null);
      setDisabled(false);
      setProfileList([]);
      setUpdating(null);
      setHelperText(false);
      setFileUrls([]);
      setNewFiles([]);
    } else {
      setHelperText(true);
    }
  };

  const handleClose = () => {
    resetValues();
    setUpdating(null);
    setDisabled(false);
    setDivideKPI(false);
    setKPIList([]);
    setFileUrls([]);
    setNewFiles([]);
  };

  const contractList = [];
  props?.employmentContractListById.forEach((e) => contractList.push(e.contract));

  const profileListFromProps = [{ id: -1, name: "" }];
  props.profileList.forEach((e) => profileListFromProps.push(e));

  // Filter timeResearchDetailList based on filter type without year filtering
  useEffect(() => {
    if (props.timeResearchInformationList?.length > 0) {
      let miniType = "JI";
      if (props.filter === "journalDomestic") miniType = "JD";
      if (props.filter === "conference") miniType = "CI";
      if (props.filter === "conferenceDomestic") miniType = "CD";

      // Get all timeResearchDetail from all years and filter by type
      let allDetails = [];
      props.timeResearchInformationList.forEach((yearData) => {
        if (yearData.timeResearchDetail) {
          allDetails = [...allDetails, ...yearData.timeResearchDetail];
        }
      });

      // B.9: chapter reuses journal scoring tables (JI or JD). See InsertModal for context.
      const typeMatch = (e) => {
        if (props.filter === "chapter") {
          return e.type === "scientificResearch-JI" || e.type === "scientificResearch-JD";
        }
        return e.type === "scientificResearch-" + miniType;
      };
      // Chapter is reward-only: no hours/points entry. Bonus picker uses its own bucket.
      const matchTypeForBonus = (e) => {
        if (props.filter === "chapter") return e.type === "scientificResearch-chapter";
        return e.type === "scientificResearch-" + miniType;
      };
      const matchTypeForLoaiCT = (e) => {
        if (props.filter === "chapter") return false;
        return e.type === "scientificResearch-" + miniType;
      };
      const baseFiltered = allDetails.filter((e) => !e.allowedUpdateNum);
      setTimeResearchDetailList(baseFiltered.filter((e) => matchTypeForLoaiCT(e) && e.rank !== 1));
      setTimeResearchDetailListForBonus(baseFiltered.filter((e) => matchTypeForBonus(e) && !!e.bonusCode));
    }
  }, [props.timeResearchInformationList, props.filter]);

  // const yearList = [];
  // props.timeResearchInformationList
  //   .sort((a, b) => b.year - a.year)
  //   .forEach((e) => {
  //     yearList.push(e.year);
  //   });

  const propsValues = {
    values: values,
    updating: updating,
    disabled: disabled,
    profileList: profileList,
    setValues: setValues,
    handleInsert: handleInsert,
    handleRemove: handleRemove,
    handleChangeForm: handleChangeForm,
    handleChangeProfileList: handleChangeProfileList,
  };

  const renderLockButton = () => {
    if (!values?.locked) return null;
    return (
      <Chip
        variant="outlined"
        label={`Đã khóa tính ${
          (values?.locked === "kpi" && "KPI") ||
          (values?.locked === "reward" && "thưởng") ||
          (values?.locked === "timeResearch" && "giờ nghiên cứu")
        }`}
        color="primary"
        style={{ fontSize: 15, float: "right", marginRight: 16 }}
      />
    );
  };

  const getTypeAsTitle = (type) => {
    switch (type) {
      case "journalInternational":
        return "trên tạp chí quốc tế";
      case "journalDomestic":
        return "trên tạp chí trong nước";
      case "conference":
        return "trên hội thảo quốc tế";
      case "conferenceDomestic":
        return "trên hội thảo trong nước";
      case "chapter":
        return "là chương sách";
      case "workingPaper":
        return "đang thực hiện";
      case "other":
        return "trên tạp chí khác";
      default:
        return "";
    }
  };
  const LinhVucBaiBao = [
    { value: "GDDT", label: "Giáo dục đào tạo" },
    { value: "KT", label: "Kinh tế" },
    { value: "QTKD", label: "Quản trị kinh doanh" },
    { value: "QL", label: "Quản lý" },
    { value: "KHAC", label: "Khác" },
  ];

  return (
    <Dialog
      fullWidth
      keepMounted
      maxWidth={false}
      open={updating !== null}
      onClose={handleClose}
      disableBackdropClick
      style={props.dialogStyle} /* [VinUni] cho phép truyền z-index khi mở chồng lên modal khác */
      PaperProps={{
        style: {
          width: "calc(100vw - 240px)",
          height: "100vh",
          maxWidth: "calc(100vw - 240px)",
          maxHeight: "100vh",
          margin: "0 0 0 240px",
        },
      }}
    >
      <DialogTitle
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 32px",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <Typography variant="h5" style={{ fontWeight: 600, marginRight: 24 }}>
            {readOnly
              ? `Xem bài báo ${getTypeAsTitle(props.filter)} (chỉ đọc)`
              : `Cập nhật bài báo ${getTypeAsTitle(props.filter)}`}
          </Typography>
          {readOnly && (
            <Chip
              size="small"
              label="Chỉ đọc"
              color="default"
              style={{ backgroundColor: "#eceff1", color: "#37474f", fontWeight: 500 }}
            />
          )}
          {renderLockButton()}
        </div>
        <div style={{ display: "flex", gap: "12px" }}>
          {props.adminTab && !readOnly && (
            <Button
              variant="outlined"
              onClick={handleSendFeedback}
              style={{ padding: "8px 24px", fontSize: "15px", fontWeight: 500 }}
            >
              Gửi feedback
            </Button>
          )}
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleClose}
            style={{
              padding: "8px 24px",
              fontSize: "15px",
              fontWeight: 500,
              borderWidth: 2,
            }}
          >
            {readOnly ? "Đóng" : "Huỷ"}
          </Button>
          {!readOnly && (
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              // [VinUni] bỏ bắt buộc chọn loại công trình (không còn tính giờ)
              disabled={
                values?.locked ||
                (props.filter !== "workingPaper" &&
                  // Required only when mục đích = Tính thưởng.
                  ((values?.purposeId === 2 || values?.purposeId === 99999999) &&
                    !values?.timeResearchDetailCodeForBonus))
              }
              style={{
                padding: "8px 24px",
                fontSize: "15px",
                fontWeight: 600,
                boxShadow: "0 2px 8px rgba(63, 81, 181, 0.3)",
              }}
            >
              Lưu thay đổi
            </Button>
          )}
          {/* [VinUni] Ẩn các nút tương tác (Duyệt/Yêu cầu chỉnh sửa) khi xem chỉ đọc */}
          {!readOnly && (
            <ModalWorkflowActions
              row={props.updating}
              role={props.role}
              onAccept={async () => {
                const ok = await props.acceptScientificResearch(props.updating.id, !props.updating.accepted, props.filter);
                if (ok) {
                  props.statisticUnaccepted({ departmentId: 0, profileId: props.profile?.id });
                  if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
                }
                return ok;
              }}
              onRequestRevision={(reason) => props.requestRevisionScientificResearch(props.updating.id, reason)}
              onAfterAction={() => props.setUpdating(null)}
            />
          )}
        </div>
      </DialogTitle>
      <DialogContent style={{ flex: 1, overflow: "hidden", display: "flex", padding: 0 }}>
        <div
          style={{
            width: "60%",
            padding: "16px 24px",
            overflowY: "auto",
            borderRight: "1px solid #e0e0e0",
          }}
        >
          {/* Revision banner — visible to người kê khai (and everyone else
              opening the modal) whenever admin is asking for changes. Once
              user clicks Lưu, BE auto-flips revision_status to
              'resubmitted' and clears the banner from future reloads. */}
          {values?.revisionStatus === "requested" && values?.revisionReason && (
            <div
              style={{
                marginBottom: 12,
                padding: 12,
                borderLeft: "4px solid #e53935",
                backgroundColor: "#ffebee",
                borderRadius: 4,
              }}
            >
              <Typography variant="subtitle2" style={{ fontWeight: 700, color: "#b71c1c", marginBottom: 4 }}>
                Phòng QLKH yêu cầu khai lại bài này
              </Typography>
              <Typography variant="body2" style={{ color: "#333", whiteSpace: "pre-line" }}>
                {values.revisionReason}
              </Typography>
              <Typography variant="caption" style={{ display: "block", marginTop: 6, color: "#666" }}>
                Vui lòng chỉnh sửa và bấm <b>Xác nhận</b> để lưu. Hệ thống sẽ tự thông báo cho Phòng QLKH để duyệt lại.
              </Typography>
            </div>
          )}
          {values?.revisionStatus === "resubmitted" && (
            <div
              style={{
                marginBottom: 12,
                padding: 12,
                borderLeft: "4px solid #1e88e5",
                backgroundColor: "#e3f2fd",
                borderRadius: 4,
              }}
            >
              <Typography variant="subtitle2" style={{ fontWeight: 700, color: "#0d47a1" }}>
                Bài đã được khai lại — đang chờ Phòng QLKH duyệt
              </Typography>
            </div>
          )}

          <Grid container spacing={2}>
            {props.filter === "journalInternational" && <JournalInternational {...propsValues} />}
            {props.filter === "journalDomestic" && <JournalDomestic {...propsValues} />}
            {props.filter === "conference" && <Conference {...propsValues} />}
            {props.filter === "conferenceDomestic" && <ConferenceDomestic {...propsValues} />}
            {props.filter === "chapter" && <Chapter {...propsValues} />}
            {props.filter === "workingPaper" && <WorkingPaper {...propsValues} />}
            {props.filter === "other" && <Other {...propsValues} />}

            {/* Commented out: Năm học tính giờ nghiên cứu */}
            {props.filter !== "workingPaper" && (
              <>
                {/* <Grid item xs={3}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    value={timeResearchYear}
                    disabled={disabled}
                    SelectProps={{ native: true }}
                    label="Năm học tính giờ nghiên cứu"
                    variant="outlined"
                    onChange={(event) => setTimeResearchYear(parseInt(event.target.value))}
                  >
                    {yearList.map((e) => (
                      <option key={`${e} - ${e + 1}`} value={parseInt(e)}>
                        {e} - {e + 1}
                      </option>
                    ))}
                  </TextField>
                </Grid> */}
                {/* Chapter (Chương sách) is reward-only and has no hours/points entry. */}
                {props.filter !== "chapter" && (
                  <Grid item xs={12}>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      disabled={disabled}
                      label="Loại công trình"
                      variant="outlined"
                      value={values?.timeResearchDetailCode || null}
                      onChange={(event) => handleChangeForm("timeResearchDetailCode", event.target.value)}
                      InputLabelProps={{
                        shrink: !(
                          values?.timeResearchDetailCode === undefined || values?.timeResearchDetailCode === null
                        ),
                      }}
                      // [VinUni] bỏ bắt buộc chọn loại công trình (không còn tính giờ)
                      error={false}
                    >
                      {timeResearchDetailList.length > 0 ? (
                        timeResearchDetailList?.map((e) => (
                          <MenuItem key={e.code} value={e.code}>
                            {e.description}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value={null} disabled>
                          Chưa có dữ liệu
                        </MenuItem>
                      )}
                    </TextField>
                  </Grid>
                )}
                {/* Loại công trình tính thưởng — only when mục đích = Tính thưởng. */}
                {(values?.purposeId === 2 || values?.purposeId === 99999999) && (
                  <Grid item xs={12}>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      disabled={disabled || values?.locked === "reward"}
                      label="Loại công trình tính thưởng"
                      variant="outlined"
                      value={values?.timeResearchDetailCodeForBonus || null}
                      onChange={(event) => handleChangeForm("timeResearchDetailCodeForBonus", event.target.value)}
                      InputLabelProps={{
                        shrink: !(
                          values?.timeResearchDetailCodeForBonus === undefined ||
                          values?.timeResearchDetailCodeForBonus === null
                        ),
                      }}
                      error={!values?.timeResearchDetailCodeForBonus}
                      helperText={
                        timeResearchDetailListForBonus?.length === 0
                          ? "Chưa có Loại công trình nào được gán bonus_code trong AdminSetting → Bảng tính giờ NC."
                          : "Bắt buộc. Quyết định mức thưởng cơ sở."
                      }
                    >
                      {timeResearchDetailListForBonus?.length > 0 ? (
                        timeResearchDetailListForBonus.map((e) => (
                          <MenuItem key={e.code} value={e.code}>
                            {e.description}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value={null} disabled>
                          Chưa có dữ liệu
                        </MenuItem>
                      )}
                    </TextField>
                  </Grid>
                )}
              </>
            )}

            {/* Bonus checkboxes — only when mục đích = Tính thưởng. */}
            {(values?.purposeId === 2 || values?.purposeId === 99999999) && (
              <Grid item xs={12}>
                <RewardBonusCheckboxGroup
                  value={values?.bonusCodes || []}
                  onChange={(codes) => handleChangeForm("bonusCodes", codes)}
                  disabled={disabled || values?.locked === "reward"}
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel id="linhVucBaiBao-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                  Lĩnh vực bài báo
                </InputLabel>
                <Select
                  native
                  fullWidth
                  labelId="linhVucBaiBao-label"
                  value={values?.linhVucBaiBao || "KHAC"}
                  disabled={disabled || values?.locked === "kpi" || values?.locked === "reward"}
                  onChange={(event) => handleChangeForm("linhVucBaiBao", event.target.value)}
                >
                  {LinhVucBaiBao.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {props.filter === "journalInternational" || props.filter === "journalDomestic" ? (
              <>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Thuộc sản phẩm của đề tài"
                    variant="outlined"
                    value={values?.thuocDeTai || ""}
                    disabled={disabled || values?.locked === "kpi" || values?.locked === "reward"}
                    multiline
                    rows={3}
                    onChange={(event) => handleChangeForm("thuocDeTai", event.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Tóm tắt"
                    variant="outlined"
                    value={values?.tomTat || ""}
                    disabled={disabled || values?.locked === "kpi" || values?.locked === "reward"}
                    multiline
                    rows={3}
                    onChange={(event) => handleChangeForm("tomTat", event.target.value)}
                  />
                </Grid>
              </>
            ) : null}
            {props.filter === "conference" || props.filter === "conferenceDomestic" ? (
              <>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Tóm tắt"
                    variant="outlined"
                    value={values?.tomTat || ""}
                    disabled={disabled || values?.locked === "kpi" || values?.locked === "reward"}
                    multiline
                    rows={3}
                    onChange={(event) => handleChangeForm("tomTat", event.target.value)}
                  />
                </Grid>
                {/* boolean - Bài báo có tranh luận */}
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={disabled || values?.locked === "kpi" || values?.locked === "reward"}
                        checked={values?.coTranhLuan || false}
                        onChange={(event) => handleChangeForm("coTranhLuan", event.target.checked)}
                        color="primary"
                      />
                    }
                    label="Bài báo có tranh luận"
                  />
                </Grid>
                {/* text - Đơn vị tổ chức */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Đơn vị tổ chức"
                    variant="outlined"
                    disabled={disabled || values?.locked === "kpi" || values?.locked === "reward"}
                    value={values?.donViToChuc || ""}
                    onChange={(event) => handleChangeForm("donViToChuc", event.target.value)}
                  />
                </Grid>
                {/* text - địa điểm tổ chức */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Địa điểm tổ chức"
                    variant="outlined"
                    disabled={disabled || values?.locked === "kpi" || values?.locked === "reward"}
                    value={values?.diaDiemToChuc || ""}
                    onChange={(event) => handleChangeForm("diaDiemToChuc", event.target.value)}
                  />
                </Grid>
              </>
            ) : null}
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Ghi chú"
                variant="outlined"
                value={values?.note || ""}
                disabled={disabled || values?.locked === "kpi" || values?.locked === "reward"}
                multiline
                rows={3}
                onChange={(event) => handleChangeForm("note", event.target.value)}
              />
            </Grid>

            {/* ============== BOX 1: Thành viên (giảng viên/CB) ============== */}
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>
            <Grid item xs={2}>
              <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Thành viên</Typography>
            </Grid>
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>

            {props?.role === "sudo-admin" && values?.purposeId === 1 && (
              <Grid item xs={12}>
                <FormControlLabel
                  disabled={disabled}
                  control={<Checkbox color="primary" checked={divideKPI} onChange={() => setDivideKPI(!divideKPI)} />}
                  label="Chia KPI"
                />
              </Grid>
            )}

            <Grid item xs={12}>
              {profileList.map((e, index) => {
                // Two flags drive layout: isInternal (true=NEU staff, false=ngoại bộ).
                // Students live in studentList / Box 2 — they never appear here.
                const memberType = e.isInternal === false ? "external" : "internal";
                const lockedDisabled = disabled || values?.locked === "kpi" || values?.locked === "reward";
                const handleChangeMemberType = (next) => {
                  const updates = {
                    internal: { isInternal: true, isStudent: false, externalName: "" },
                    external: { isInternal: false, isStudent: false, profileId: null, orgCount: 1, orgRatio: 1 },
                  }[next] || {};
                  const merged = { ...profileList[index], ...updates };
                  const tmp = [...profileList];
                  tmp.splice(index, 1, merged);
                  setProfileList(tmp);
                  if (next !== "internal" && profileList[index]?.profileId === values?.profileIdForKpi) {
                    handleChangeForm("profileIdForKpi", null);
                  }
                };
                // Compute Row 2 column widths so the row always sums to exactly 12.
                // Layouts (internal):
                //   base:                 orgCount(2) + role(5) + status(4) + remove(1)
                //   purpose=KPI:          orgCount(2) + role(3) + kpi(3) + status(3) + remove(1)
                //   purpose=KPI+divide:   orgCount(1) + role(2) + kpi(2) + coef(3) + viz(1) + status(2) + remove(1)
                //   purpose=Reward:       orgCount(2) + role(3) + reward(3) + status(3) + remove(1)
                // External skips orgCount; the freed slot goes to role.
                const purpose1 = values?.purposeId === 1;
                const purpose9 = values?.purposeId === 99999999;
                const isInt = memberType === "internal";
                let cols;
                if (purpose1 && divideKPI) {
                  cols = isInt
                    ? { orgCount: 1, role: 2, kpi: 2, coef: 3, viz: 1, status: 2, remove: 1 }
                    : { orgCount: 0, role: 3, kpi: 2, coef: 4, viz: 1, status: 1, remove: 1 };
                } else if (purpose1) {
                  cols = isInt
                    ? { orgCount: 2, role: 3, kpi: 3, status: 3, remove: 1 }
                    : { orgCount: 0, role: 4, kpi: 3, status: 4, remove: 1 };
                } else if (purpose9) {
                  cols = isInt
                    ? { orgCount: 2, role: 3, reward: 3, status: 3, remove: 1 }
                    : { orgCount: 0, role: 4, reward: 3, status: 4, remove: 1 };
                } else {
                  cols = isInt
                    ? { orgCount: 2, role: 5, status: 4, remove: 1 }
                    : { orgCount: 0, role: 7, status: 4, remove: 1 };
                }
                return (
                  <Grid
                    key={`list-${index}`}
                    container
                    spacing={2}
                    style={{
                      border: "1px solid #e0e0e0",
                      borderRadius: 6,
                      padding: 12,
                      marginBottom: 12,
                      marginLeft: 0,
                      width: "100%",
                    }}
                  >
                    {/* ----- Row 1 (xs sum = 12): identity ----- */}
                    <Grid item xs={2}>
                      <FormControl fullWidth variant="outlined" size="small">
                        <InputLabel
                          id={`memberType-label-${index}`}
                          style={{ padding: "0 8px", backgroundColor: "white" }}
                        >
                          Loại thành viên
                        </InputLabel>
                        <Select
                          native
                          fullWidth
                          disabled={lockedDisabled}
                          labelId={`memberType-label-${index}`}
                          value={memberType}
                          onChange={(event) => handleChangeMemberType(event.target.value)}
                        >
                          <option value="internal">Nội bộ</option>
                          <option value="external">Ngoại bộ</option>
                        </Select>
                      </FormControl>
                    </Grid>
                    {isInt ? (
                      <>
                        <Grid item xs={4}>
                          <Autocomplete
                            disableClearable
                            disabled={disabled}
                            options={props.profileList}
                            getOptionLabel={(option) => option.name}
                            value={props.profileList?.find((profile) => profile.id === e.profileId)}
                            onChange={(event, profile) => {
                              if (profileList[index]?.profileId === values?.profileIdForKpi)
                                handleChangeForm("profileIdForKpi", null);
                              handleChangeProfileList(index, "profileId", parseInt(profile?.id));
                              if (parseInt(profile?.id) >= 0) setHelperText(false);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={helperText && e.profileId === null}
                                size="small"
                                label="Thành viên"
                                variant="outlined"
                              />
                            )}
                          />
                          {helperText && e.profileId === null && (
                            <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                          )}
                        </Grid>
                        <Grid item xs={3}>
                          <TextField
                            fullWidth
                            size="small"
                            disabled
                            variant="outlined"
                            label="Mã viên chức"
                            value={props.profileList?.find((profile) => profile.id === e.profileId)?.code || ""}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <TextField
                            fullWidth
                            size="small"
                            disabled
                            variant="outlined"
                            label="Đơn vị"
                            value={
                              props.profileList?.find((profile) => profile.id === e.profileId)?.departmentProfile?.[0]
                                ?.department?.name || ""
                            }
                          />
                        </Grid>
                      </>
                    ) : (
                      <Grid item xs={10}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          label="Tên thành viên ngoại bộ"
                          disabled={lockedDisabled}
                          value={e?.externalName || ""}
                          onChange={(event) => handleChangeProfileList(index, "externalName", event.target.value)}
                          error={helperText && e.externalName === ""}
                          helperText={helperText && e.externalName === "" ? "Không được để trống" : ""}
                        />
                      </Grid>
                    )}

                    {/* ----- Row 2 (xs sum = 12): config + actions ----- */}
                    {isInt && (
                      <Grid item xs={cols.orgCount}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          type="number"
                          label="Số ĐV"
                          disabled={lockedDisabled}
                          inputProps={{ min: 1, step: 1 }}
                          value={e?.orgCount ?? 1}
                          onChange={(event) => {
                            const n = Math.max(1, parseInt(event.target.value, 10) || 1);
                            const tmp = [...profileList];
                            tmp.splice(index, 1, { ...profileList[index], orgCount: n, orgRatio: 1 / n });
                            setProfileList(tmp);
                          }}
                        />
                      </Grid>
                    )}
                    <Grid item xs={cols.role}>
                      <FormControl fullWidth variant="outlined" size="small">
                        <InputLabel
                          id={`roleInPaper-label-${index}`}
                          style={{ padding: "0 8px", backgroundColor: "white" }}
                        >
                          Vai trò được giao
                        </InputLabel>
                        <Select
                          native
                          fullWidth
                          disabled={disabled}
                          labelId={`roleInPaper-label-${index}`}
                          value={e?.roleInPaper || "main"}
                          onChange={(event) => handleChangeProfileList(index, "roleInPaper", event.target.value)}
                        >
                          <option value="main">Tác giả chính</option>
                          {props.filter.includes("journal") && (
                            <option value="member">Không phải tác giả chính</option>
                          )}
                          {props.filter.includes("conference") && <option value="member">Đồng tác giả</option>}
                        </Select>
                      </FormControl>
                    </Grid>
                    {purpose1 && (
                      <Grid item xs={cols.kpi}>
                        <FormControl required fullWidth disabled={disabled} error={!values?.profileIdForKpi}>
                          <Button
                            fullWidth
                            color="primary"
                            variant="outlined"
                            style={{ height: 40 }}
                            disabled={lockedDisabled}
                            startIcon={isCheckedForKPI(e) ? <CheckBox /> : <CheckBoxOutlineBlank />}
                            onClick={() => {
                              setDetail(null);
                              if (!divideKPI) {
                                props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                                handleChangeForm(
                                  "profileIdForKpi",
                                  values?.profileIdForKpi !== e.profileId ? parseInt(e.profileId) : null,
                                );
                              } else {
                                setFocusProfile(e.profileId);
                                props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                                if (KPIList.find((kpi) => e.profileId === kpi?.profileId)) {
                                  setKPIList(KPIList.filter((kpi) => e.profileId !== kpi?.profileId));
                                } else {
                                  setKPIList([...KPIList, { profileId: e.profileId, coef: 0 }]);
                                }
                              }
                            }}
                          >
                            Tính KPI
                          </Button>
                        </FormControl>
                      </Grid>
                    )}
                    {purpose1 && divideKPI && (
                      <Grid item xs={cols.coef}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Hệ số"
                          variant="outlined"
                          value={KPIList.find((kpi) => e.profileId === kpi?.profileId)?.coef || 0}
                          disabled={disabled || !KPIList.find((kpi) => e.profileId === kpi?.profileId)}
                          onChange={(event) =>
                            setKPIList([
                              ...KPIList.filter((kpi) => e?.profileId !== kpi?.profileId),
                              { profileId: e?.profileId, coef: event.target.value },
                            ])
                          }
                        />
                      </Grid>
                    )}
                    {purpose1 && divideKPI && (
                      <Grid item xs={cols.viz}>
                        <Button
                          fullWidth
                          disabled={disabled}
                          variant="outlined"
                          style={{ height: 40 }}
                          onClick={() => {
                            props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                            setFocusProfile(e.profileId);
                          }}
                        >
                          <Visibility />
                        </Button>
                      </Grid>
                    )}
                    {purpose9 && (
                      <Grid item xs={cols.reward}>
                        <FormControl fullWidth disabled={disabled} error={!values?.profileIdForReward}>
                          <Button
                            fullWidth
                            color="primary"
                            variant="outlined"
                            style={{ height: 40 }}
                            disabled={lockedDisabled}
                            startIcon={
                              typeof values?.profileIdForReward === "number" &&
                              values?.profileIdForReward === e.profileId ? (
                                <CheckBox />
                              ) : (
                                <CheckBoxOutlineBlank />
                              )
                            }
                            onClick={() => {
                              setDetail(null);
                              props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                              setFocusProfile(e.profileId);
                              handleChangeForm(
                                "profileIdForReward",
                                values?.profileIdForReward !== e.profileId ? parseInt(e.profileId) : null,
                              );
                            }}
                          >
                            Tính thưởng
                          </Button>
                        </FormControl>
                      </Grid>
                    )}
                    <Grid item xs={cols.status}>
                      <FormControl fullWidth variant="outlined" size="small">
                        <InputLabel
                          id={`statusInProject-label-${index}`}
                          style={{ padding: "0 8px", backgroundColor: "white" }}
                        >
                          Trạng thái
                        </InputLabel>
                        <Select
                          native
                          fullWidth
                          disabled={lockedDisabled}
                          labelId={`statusInProject-label-${index}`}
                          value={e?.statusInProject || "K"}
                          onChange={(event) => handleChangeProfileList(index, "statusInProject", event.target.value)}
                        >
                          <option value="NCS">Đang làm NCS</option>
                          <option value="CH">Đang học Cao học</option>
                          <option value="K">Khác</option>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={cols.remove}>
                      <Button
                        fullWidth
                        disabled={disabled}
                        color="secondary"
                        variant="contained"
                        style={{ height: 40 }}
                        onClick={() => handleRemove(index)}
                      >
                        Xoá
                      </Button>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>

            <Grid item xs={12}>
              <Button fullWidth disabled={disabled} variant="outlined" onClick={handleInsert}>
                Thêm thành viên
              </Button>
            </Grid>

            {/* ============== BOX 2: Sinh viên / Học viên ============== */}
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>
            <Grid item xs={2}>
              <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Sinh viên</Typography>
            </Grid>
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>

            <Grid item xs={12}>
              {studentList.map((s, index) => (
                <Grid
                  key={`student-${index}`}
                  container
                  spacing={2}
                  style={{
                    border: "1px solid #e0e0e0",
                    borderRadius: 6,
                    padding: 12,
                    marginBottom: 12,
                    marginLeft: 0,
                    width: "100%",
                  }}
                >
                  {/* xs sum = 12 */}
                  <Grid item xs={5}>
                    <TextField
                      required
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Tên sinh viên / học viên"
                      disabled={disabled || values?.locked === "reward"}
                      value={s?.studentName || ""}
                      error={helperText && !s.studentName}
                      helperText={helperText && !s.studentName ? "Không được để trống" : ""}
                      onChange={(event) => handleChangeStudentList(index, "studentName", event.target.value)}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Mã sinh viên / học viên"
                      disabled={disabled || values?.locked === "reward"}
                      value={s?.studentCode || ""}
                      onChange={(event) => handleChangeStudentList(index, "studentCode", event.target.value)}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Mã lớp"
                      disabled={disabled || values?.locked === "reward"}
                      value={s?.studentClass || ""}
                      onChange={(event) => handleChangeStudentList(index, "studentClass", event.target.value)}
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <Button
                      fullWidth
                      disabled={disabled}
                      color="secondary"
                      variant="contained"
                      style={{ height: 40 }}
                      onClick={() => handleRemoveStudent(index)}
                    >
                      Xoá
                    </Button>
                  </Grid>
                </Grid>
              ))}
            </Grid>

            <Grid item xs={12}>
              <Button fullWidth disabled={disabled} variant="outlined" onClick={handleInsertStudent}>
                Thêm sinh viên
              </Button>
            </Grid>
          </Grid>
        </div>
        <div
          style={{
            flexDirection: "column",
            display: values?.profileIdForKpi !== null && values?.profileIdForKpi >= 0 ? "block" : "none",
          }}
        >
          <EmploymentContractTable
            values={values}
            contract={detail}
            KPIList={KPIList}
            divideKPI={divideKPI}
            focusProfile={focusProfile}
            contractList={contractList}
            kpiIdForKpi={values?.kpiIdForKpi}
            disabled={disabled || values?.locked}
            contractIdForKpi={values?.contractIdForKpi}
            setDetail={setDetail}
            setValues={setValues}
            setKPIList={setKPIList}
            handleChangeForm={handleChangeForm}
          />
          {/* <EmploymentContractTable
            values={values}
            contract={detail}
            KPIList={KPIList}
            divideKPI={divideKPI}
            contractList={contractList}
            kpiIdForKpi={values?.kpiIdForKpi}
            disabled={disabled || values?.locked}
            contractIdForKpi={values?.contractIdForKpi}
            setDetail={setDetail}
            setValues={setValues}
            setKPIList={setKPIList}
            handleChangeForm={handleChangeForm}
          /> */}
          <EmploymentContractDetailTable disabled={disabled || values?.locked} kpi={detail} />
        </div>
        <div
          style={{
            width: "40%",
            padding: "16px 24px",
            overflowY: "auto",
            backgroundColor: "#fafafa",
          }}
        >
          <Typography variant="h6" style={{ marginBottom: 16 }}>
            Upload file minh chứng
          </Typography>
          <div
            style={{
              backgroundColor: "#ffebee",
              color: "#c62828",
              padding: "12px",
              marginBottom: 16,
              borderRadius: 4,
              whiteSpace: "pre-line",
            }}
          >
            {`Upload file Scan bản gốc:
1. Bìa
2. Mục lục có tên tác giả
3. Trang đầu của bài viết
4. Trang có đăng ký số giấy phép xuất bản hoặc số ISSN
5. Đường link. Nếu bài báo không có đường link phải cung cấp đủ các minh chứng trên và toàn bộ bản mềm của bài báo
Ghi chú:
- Việc kê khai công trình phải ghi đầy đủ tên bài báo/bài hội thảo, từ trang bao nhiêu trong tạp chí/kỷ yếu.
- Tác giả chính nếu không có xác nhận của BBT hoặc quy định của Tạp chí thì được hiểu là corresponding author hoặc tác giả đứng đầu.`}
          </div>
          <MultiFileManager
            fileUrls={fileUrls}
            setFileUrls={setFileUrls}
            newFiles={newFiles}
            setNewFiles={setNewFiles}
            disabled={disabled}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  history: select(state, "homeReducer", "history"),
  profile: select(state, "profileReducer", "detail"),
  profileList: select(state, "profileReducer", "list"),
  detailYear: select(state, "timeResearchInformationReducer", "detail"),
  employmentContractDetail: select(state, "employmentContractReducer", "detail"),
  employmentContractListById: select(state, "employmentContractReducer", "listById"),
  timeResearchInformationList: select(state, "timeResearchInformationReducer", "list"),
  isFetchingTimeResearchInformation: select(state, "timeResearchInformationReducer", "isFetching"),
  listJournalDomestic: select(state, "journalDomesticReducer", "list"),
  listConference: select(state, "conferenceReducer", "list"),
  journalDetail: select(state, "journalReducer", "detailOnScientificResearch"),
  isFetchingJournalDetail: select(state, "journalReducer", "isFetchingDetailOnScientificResearch"),
});

const mapDispatchToProps = (dispatch) => ({
  uploadMultiFile: (id, files, type) => dispatch(uploadMultiFile(id, files, type)),
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  getEmploymentContractById: (id) => dispatch(getEmploymentContractById(id)),
  updateScientificResearch: (id, payload) => dispatch(updateScientificResearch(id, payload)),
  acceptScientificResearch: (id, accept, filter) => dispatch(acceptScientificResearch(id, accept, filter)),
  requestRevisionScientificResearch: (id, reason) => dispatch(requestRevisionScientificResearch(id, reason)),
  getAllEmploymentContractByProfileId: (id) => dispatch(getAllEmploymentContractByProfileId(id)),
  updateScientificResearchOther: (id, payload) => dispatch(updateScientificResearchOther(id, payload)),
  getJournalByIdOnScientificResearch: (id) => dispatch(getJournalByIdOnScientificResearch(id)),
  getAllJournalDomestic: () => dispatch(getAllJournalDomestic()),
  getAllConference: () => dispatch(getAllConference()),
  notification: (data) => dispatch(notification(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(ScientificResearchUpdateModal));

